var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "userview" } },
    [
      _c(
        "v-card",
        { attrs: { "max-width": "800px" } },
        [
          _c("v-card-title", [_vm._v(_vm._s(_vm.title))]),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("users.name"),
                      required: "",
                      rules: [_vm.rules.required]
                    },
                    model: {
                      value: _vm.model.displayName,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "displayName", $$v)
                      },
                      expression: "model.displayName"
                    }
                  }),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("users.email"),
                      rules: [_vm.rules.emailRules],
                      disabled: _vm.model.authID !== undefined,
                      required: ""
                    },
                    model: {
                      value: _vm.model.email,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "email", $$v)
                      },
                      expression: "model.email"
                    }
                  }),
                  _c("v-combobox", {
                    attrs: {
                      label: _vm.$t("users.roles"),
                      required: "",
                      rules: [_vm.rules.roleRules],
                      multiple: "",
                      chips: "",
                      items: _vm.assignableRoles
                    },
                    model: {
                      value: _vm.model.roles,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "roles", $$v)
                      },
                      expression: "model.roles"
                    }
                  }),
                  _c("v-text-field", {
                    attrs: { label: _vm.$t("users.tag") },
                    model: {
                      value: _vm.model.tag,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "tag", $$v)
                      },
                      expression: "model.tag"
                    }
                  }),
                  _vm.invited
                    ? _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("users.registration-link"),
                          readonly: "",
                          hint:
                            "Share this link with user if Bodyswaps emails are blocked"
                        },
                        model: {
                          value: _vm.registrationLink,
                          callback: function($$v) {
                            _vm.registrationLink = $$v
                          },
                          expression: "registrationLink"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1" },
                  on: { click: _vm.cancel }
                },
                [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { disabled: !_vm.valid, color: "success" },
                  on: { click: _vm.validate }
                },
                [_vm._v(" " + _vm._s(_vm.$t("global.save")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }